import { useQuery } from "@apollo/client";
import { useParams } from "react-router-dom";
import { ReportView } from "../../components/reports/ReportView";
import { PROJECT_PUBLIC } from "../../graphql/queries/ProjectQueries";
import { WithQueryLoader } from "../../components/shared/WithQueryLoader";

export interface ReportPageProps {
  isPublicDisplay?: boolean;
}

export const ReportPage = ({ isPublicDisplay }: ReportPageProps) => {
  const { projectId } = useParams();

  if (!projectId) {
    return null;
  }

  // TODO: move fetching logic to router
  const { data, loading } = useQuery(PROJECT_PUBLIC, {
    variables: {
      projectId,
    },
  });

  if (!data?.projectPublic) {
    return <div></div>;
  }

  if (isPublicDisplay && !data.projectPublic.public) {
    return <div>Project is not public</div>;
  }

  return (
    <WithQueryLoader isLoading={loading}>
      <ReportView project={data.projectPublic} games={data.projectPublic.games} isPublicDisplay={isPublicDisplay} />
    </WithQueryLoader>
  );
};
